import { render, staticRenderFns } from "./AlipayMyPage.vue?vue&type=template&id=452bb687&scoped=true"
import script from "./AlipayMyPage.vue?vue&type=script&lang=js"
export * from "./AlipayMyPage.vue?vue&type=script&lang=js"
import style0 from "./AlipayMyPage.vue?vue&type=style&index=0&id=452bb687&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452bb687",
  null
  
)

export default component.exports